import DeleteIconButton from '@shared/components/core/button/DeleteIconButton';
import HorizontalFieldContainer from '@shared/components/core/field/HorizontalFieldContainer';
import { IconName } from '@shared/components/core/images/IconMap';
import Icons from '@shared/components/core/images/Icons';
import { CommandType, commandTypesDisplay } from '@shared/constants/CommandValues';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ControlTypeField } from './ControlTypeField';

interface CommandFieldProps {
    value: string;
    onChange: (value: string) => void;
    onRemove: () => void;
    commandType: CommandType;
    disabled?: boolean;
    startIcon?: IconName;
}

const CommandField: React.FC<CommandFieldProps> = ({ value, onChange, onRemove, commandType, startIcon, disabled }) => {
    const { t } = useTranslation();
    const fallbackIcon: IconName = startIcon || commandTypesDisplay[commandType]?.icon;
    return (
        <HorizontalFieldContainer>
            {fallbackIcon && <Icons size={42} name={fallbackIcon} />}
            <ControlTypeField control={commandType} value={value} onChange={onChange} disabled={disabled} />
            <DeleteIconButton onClick={onRemove} showLabel={false}>
                {t('common:input.remove')}
            </DeleteIconButton>
        </HorizontalFieldContainer>
    );
};

export default CommandField;
